import { getCurrentInstance } from 'vue';

const useLocale = () => {
  const instance = getCurrentInstance()?.proxy;
  const t = (key: string, ...params: unknown[]) =>
    // @ts-ignore
    instance.$t(key, ...params);
  const n = (value: number) =>
    // @ts-ignore
    instance.$n(value);

  const locale = () =>
    // @ts-ignore
    instance.$i18n.locale as string;

  return { t, n, locale };
};

export default useLocale;
